import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=4b45e1d4&scoped=true"
import script from "./tags.vue?vue&type=script&lang=ts"
export * from "./tags.vue?vue&type=script&lang=ts"
import style0 from "./tags.vue?vue&type=style&index=0&id=4b45e1d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b45e1d4",
  null
  
)

/* custom blocks */
import block0 from "./tags.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports